import { __ } from '~/locale';
import WikiDiscussionSorter from './wiki_discussion_sorter.vue?vue3';
export default {
    name: 'WikiNotesActivityHeader',
    components: {
        WikiDiscussionSorter
    },
    i18n: {
        headerText: __('Comments')
    }
};
